import { clearCuttingRules } from '@/utils/cuttingRules'
// export const getImgSizeByUrl = (url: string) => {
//     return new Promise((resolve, reject) => {
//         const img = new Image();
//         img.onload = () => {
//             resolve({
//                 width: img.width,
//                 height: img.height
//             });
//         };
//         img.onerror = () => {
//             reject(new Error('图片加载失败'));
//         };
//         // 如果图像位于不同的域，则需要设置 crossOrigin 属性以避免 CORS 问题
//         img.crossOrigin = 'anonymous';
//         img.src = url + `?_t= `+ new Date();
//     });
// };
/**
 * 根据图片地址获取宽高
 * @param url 图片地址
 * @param timeout 超时时间（毫秒），默认 10000；超时或失败时 reject，避免 Promise 挂起
 * @returns 返回图片宽高
 */
export const getImgSizeByUrl = (url: string, timeout = 10000): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const controller = new AbortController()
    const timer = setTimeout(() => {
      controller.abort()
      reject(new Error('获取图片尺寸超时'))
    }, timeout)
    // 统一在完成时清除定时器并执行回调
    const finish = (handler: () => void) => {
      clearTimeout(timer)
      handler()
    }

    if (url.indexOf('!') >= 0) {
      const img = new Image()
      img.onload = () => {
        finish(() => {
          resolve({
            width: img.width,
            height: img.height,
          })
        })
      }
      img.onerror = () => {
        finish(() => reject(new Error('图片加载失败')))
      }
      // 如果图像位于不同的域，则需要设置 crossOrigin 属性以避免 CORS 问题
      img.crossOrigin = 'anonymous'
      img.src = url + `?_t=${new Date().getTime()}`

    } else {

      let originalImgUrl = clearCuttingRules(url)
      // 关键修改：拼接OSS的info接口
      const infoUrl = `${originalImgUrl}?x-oss-process=image/info`

      fetch(infoUrl, { signal: controller.signal })
        .then((response) => {
          if (!response.ok) throw new Error(`OSS请求失败: ${response.status}`)
          return response.json()
        })
        .then((data) => {
          if (data.ImageHeight && data.ImageWidth) {
            finish(() => {
              resolve({
                width: Number(data.ImageWidth.value),
                height: Number(data.ImageHeight.value),
              })
            })
          } else {
            finish(() => reject(new Error('OSS返回数据格式异常')))
          }
        })
        .catch((error) => {
          finish(() => reject(new Error(`获取图片尺寸失败: ${error?.message || error}`)))
        })
    }
  })
}

export const parseSearch = (search: string) => {
  if (!search || !search.startsWith('?')) return {}
  const params: any = new URLSearchParams(search.substring(1))
  const result: any = {}
  for (let [key, value] of params) {
    result[key] = value
  }
  return result
}

// 小数取四位
export const toFourDecimal = (num: number) => {
  return Math.round(num * 10000) / 10000
}

// export function getIsMobileDevice() {
//     const _window = window as any;
//     var userAgent = navigator.userAgent || navigator.vendor || _window.opera;
//     // 常见的移动设备标识
//     var mobileRegex = /iPad|iPhone|iPod|Android|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS\/|FxiOS\//;

//     // console.log('userAgent------', userAgent, 'isM+++++++:',mobileRegex.test(userAgent))
//     return mobileRegex.test(userAgent);
// }

export function getIsMobileDevice(): boolean {
  // 平板典型特征：触控屏、不能悬停、中等宽度
  return window.matchMedia('(min-width: 768px) and ' + '(max-width: 1400px) and ' + '(pointer: coarse) and ' + '(hover: none)').matches
}

// 下载ps插件
export function downloadPsPlugIn() {
  const url = `https://3d66-render.oss-cn-zhangjiakou.aliyuncs.com/PsAITool/PsAITool.zip`
  // 创建隐藏的 <a> 标签模拟点击下载
  const a = document.createElement('a')
  a.href = url
  a.download = 'PsAITool.zip'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}